<script setup lang="ts">
defineProps<{
  isLoading: boolean;
}>();
</script>

<template>
  <button class="btn btn-primary" type="submit" :disabled="isLoading">
    <slot />
    <span
      v-if="isLoading"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
  </button>
</template>
